import React from 'react'

import SharedComponent from './SharedComponent'

const CreateMainComponent = (props) => <SharedComponent {...props} />

export default CreateMainComponent
